<template>
  <div class="sm:container">
    <div>
      <div class="logo">
        <img
          src="../../assets/images/logo/logo-bemprotege-b46d35ad.png"
          width="200"
        />
      </div>
      <vx-card class="sm:p-6">
        <form-wizard
          shape="circle"
          color="#3498db"
          subtitle=""
          nextButtonText="Próximo"
          backButtonText="Voltar"
          finishButtonText="Concluir"
        >
          <h2 slot="title" style="color: #59595a">FAÇA PARTE DO NOSSO TIME</h2>
          <tab-content
            title="Inscrição"
            icon="feather icon-user"
            :before-change="validateStepOne"
          >
            <div id="step1">
              <div class="vx-row">
                <div class="vx-col sm:w-2/5 w-full mb-6">
                  <span>Nome</span>
                  <vs-input
                    size="large"
                    class="w-full"
                    name="Nome"
                    id="Nome"
                    v-model="formCadastro.nome"
                    v-validate="{ required: true, min: 6 }"
                    :state="validateState('Nome')"
                    :danger="validateClass('Nome')"
                    danger-text="Preencha este Campo"
                    icon-pack="feather"
                    icon="icon-user"
                    icon-no-border
                  />
                </div>

                <div class="vx-col sm:w-2/5 w-full mb-6">
                  <span>Email</span>
                  <vs-input
                    type="email"
                    size="large"
                    class="w-full"
                    name="Email"
                    id="Email"
                    :state="validateState('Email')"
                    :danger="validateClass('Email')"
                    v-model="formCadastro.email"
                    v-validate="{ required: true, email: true }"
                    val-icon-danger="clear"
                    danger-text="Insira um e-mail válido"
                    icon-pack="feather"
                    icon="icon-mail"
                    icon-no-border
                  />
                </div>

                <div class="vx-col sm:w-1/5 w-full mb-6">
                  <span>WhatsApp</span>
                  <vs-input
                    size="large"
                    class="w-full"
                    name="Celular"
                    id="Celular"
                    :state="validateState('Celular')"
                    :danger="validateClass('Celular')"
                    v-model="formCadastro.celular"
                    v-validate="{ required: true, min: 15 }"
                    v-mask="'(##) #####-####'"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-pack="feather"
                    icon="icon-smartphone"
                    icon-no-border
                  />
                </div>

                <div class="w-full">
                  <div class="vx-col w-full">
                    <vs-alert color="primary" active="true">
                      <div class="divLgpd">
                      <p >
                        Você aceita fornecer os dados solicitados no formulário
                        para fazer parte do time Bem Protege?
                      </p>
                      <div class="lgpdLink mt-1 mb-1" @click="exibirTermos()">
                        Consulte nossa politíca de proteção de dados
                      </div>
                      ou
                      <a
                        href="http://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/L13709.htm "
                        target="_blank"
                        >Clique aqui</a
                      >
                      para acessar a LEI Nº 13.709, DE 14 DE AGOSTO DE 2018
                      <div class="flex pt-4 gap-3 text-sm">
                        <p>Aceito os Termos</p>
                        <vs-switch
                          color="success"
                          name="AceitaLgpd"
                          id="AceitaLgpd"
                          :state="validateState('AceitaLgpd')"
                          :danger="validateClass('AceitaLgpd')"
                          val-icon-danger="clear"
                          v-validate="{ required: true }"
                          v-model="formCadastro.aceitaLgpd"
                          danger-text="Aceite os termos para prosseguir!"
                          style="size: 15px" >
                          <span slot="on">sim</span>
                          <span slot="off">não</span>
                        </vs-switch>
                      </div>
                    </div>
                    </vs-alert>
                  </div>
                  <vs-alert
                  color="dark"
                    class="lgpdAlert"
                    closable
                    close-icon="close"
                    :active.sync="active5"
                  >
                    {{ this.termoLgpd }}</vs-alert
                  >
                </div>
              </div>
            </div>
          </tab-content>
          <tab-content
            title="Dados Complementares"
            icon="feather icon-home"
            :before-change="validateStepTwo"
          >
            <div id="step2">
              <div class="vx-row">
                <div class="vx-col sm:w-3/12 w-full mb-6">
                  <span>CPF</span>
                  <vs-input
                    size="large"
                    class="w-full"
                    name="CPF"
                    id="CPF"
                    v-model="formCadastro.cpf"
                    @keyup.native="keymonitor2"
                    v-validate="{ required: true, min: 14 }"
                    :state="validateState('CPF')"
                    :danger="validateClass('CPF')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    v-mask="'###.###.###-##'"
                    icon-pack="feather"
                    icon="icon-user-check"
                    icon-no-border
                  />
                </div>

                <div class="vx-col w-full sm:w-2/12 mb-6">
                  <span>Data de Nascimento</span>
                  <vs-input
                    size="large"
                    class="w-full"
                    name="DataNascimento"
                    id="DataNascimento"
                    v-model="formCadastro.dataNascimento"
                    v-validate="{ required: true, date_format: 'dd/MM/yyyy' }"
                    :state="validateState('DataNascimento')"
                    :danger="validateClass('DataNascimento')"
                    val-icon-danger="clear"
                    v-mask="'##/##/####'"
                    danger-text="Preencha este Campo"
                    icon-pack="feather"
                    icon="icon-calendar"
                    icon-no-border
                  />
                </div>

                <div class="vx-col sm:w-2/12 w-full mb-6">
                  <span>CEP</span>
                  <vs-input
                    size="large"
                    class="w-full"
                    name="Cep"
                    id="Cep"
                    @keyup.native="keymonitor"
                    v-model="formCadastro.cep"
                    v-validate="{ required: true, min: 10 }"
                    :state="validateState('Cep')"
                    :danger="validateClass('Cep')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    v-mask="'##.###-###'"
                    icon-pack="feather"
                    icon="icon-home"
                    icon-no-border
                  />
                </div>

                <div class="vx-col sm:w-5/12 w-full mb-6">
                  <span>Endereço</span>
                  <vs-input
                    size="large"
                    class="w-full"
                    name="Endereco"
                    id="Endereco"
                    v-model="formCadastro.endereco"
                    v-validate="{ required: true, min: 6 }"
                    :state="validateState('Endereco')"
                    :danger="validateClass('Endereco')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-pack="feather"
                    icon="icon-check-circle"
                    icon-no-border
                  />
                </div>

                <div class="vx-col sm:w-2/12 w-1/2 mb-6">
                  <span>Número</span>
                  <vs-input
                    size="large"
                    class="w-full"
                    name="Numero"
                    id="Numero"
                    v-model="formCadastro.numero"
                    v-validate="{ required: true }"
                    :state="validateState('Numero')"
                    :danger="validateClass('Numero')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-pack="feather"
                    icon="icon-check-circle"
                    icon-no-border
                  />
                </div>

                <div class="vx-col sm:w-2/12 w-1/2 mb-6">
                  <span>Complemento</span>
                  <vs-input
                    size="large"
                    class="w-full"
                    name="Complemento"
                    id="Complemento"
                    v-model="formCadastro.complemento"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                  />
                </div>

                <div class="vx-col sm:w-3/12 w-full mb-6">
                  <span>Bairro</span>
                  <vs-input
                    size="large"
                    class="w-full"
                    name="Bairro"
                    id="Bairro"
                    v-model="formCadastro.bairro"
                    v-validate="{ required: true }"
                    :state="validateState('Bairro')"
                    :danger="validateClass('Bairro')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-pack="feather"
                    icon="icon-check-circle"
                    icon-no-border
                  />
                </div>

                <div class="vx-col sm:w-3/12 w-2/3 mb-6">
                  <span>Cidade</span>
                  <vs-input
                    size="large"
                    class="w-full"
                    name="Cidade"
                    id="Cidade"
                    v-model="formCadastro.cidade"
                    v-validate="{ required: true }"
                    :state="validateState('Cidade')"
                    :danger="validateClass('Cidade')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-pack="feather"
                    icon="icon-check-circle"
                    icon-no-border
                  />
                </div>

                <div class="vx-col sm:w-2/12 w-1/3 mb-6">
                  <span>Estado</span>
                  <vs-input
                    size="large"
                    class="w-full"
                    name="Estado"
                    id="Estado"
                    v-model="formCadastro.estado"
                    v-validate="{ required: true, min: 2, max: 2 }"
                    :state="validateState('Estado')"
                    :danger="validateClass('Estado')"
                    v-mask="'AA'"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-pack="feather"
                    icon="icon-check-circle"
                    icon-no-border
                  />
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-6">
                  <span>Senha</span>
                  <vs-input
                    type="password"
                    size="large"
                    class="w-full"
                    name="Senha"
                    id="Senha"
                    :state="validateState('Senha')"
                    :danger="validateClass('Senha')"
                    v-model="formCadastro.senha"
                    v-validate="{ required: true, min: 8 }"
                    val-icon-danger="clear"
                    danger-text="min: 8 caractéres"
                    icon-pack="feather"
                    icon="icon-lock"
                    icon-no-border
                  />
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-6">
                  <span>Confirmação da Senha</span>
                  <vs-input
                    type="password"
                    size="large"
                    class="w-full"
                    name="Senha2"
                    id="Senha2"
                    :state="validateState('Senha2')"
                    :danger="validateClass('Senha2')"
                    v-model="formCadastro.senha2"
                    v-validate="{
                      required: true,
                      confirmed: formCadastro.senha,
                    }"
                    val-icon-danger="clear"
                    danger-text="Senha não Confere"
                    icon-pack="feather"
                    icon="icon-lock"
                    icon-no-border
                  />
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col sm:w-5/12 gap-3 w-full mb-10 mt-10 flex">
                  <span> Já tem experiência com proteção veicular? </span>
                  <vs-switch
                    color="success"
                    v-model="formCadastro.experiencia"
                    style="width: 60px"
                  >
                    <span slot="on">sim</span>
                    <span slot="off">não</span>
                  </vs-switch>
                </div>

                <div class="vx-col sm:w-4/12 gap-3 w-full mb-10 mt-10 flex">
                  <span>Foi indicado por alguem?</span>
                  <vs-switch
                    color="success"
                    v-model="formCadastro.indicacao"
                    style="width: 60px"
                  >
                    <span slot="on">sim</span>
                    <span slot="off">não</span>
                  </vs-switch>
                </div>

                <div
                  v-if="formCadastro.indicacao"
                  class="vx-col sm:w-3/12 w-full"
                >
                  <span>Nome de quem o indicou</span>
                  <vs-input
                    size="large"
                    class="w-full"
                    name="NomeIndicacao"
                    id="NomeIndicacao"
                    v-model="formCadastro.nomeIndicacao"
                    v-validate="{ required: true, min: 4 }"
                    :state="validateState('NomeIndicacao')"
                    :danger="validateClass('NomeIndicacao')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    icon-pack="feather"
                    icon="icon-user"
                    icon-no-border
                  />
                </div>
              </div>
            </div>
          </tab-content>
          <tab-content title="Conclusão" icon="feather icon-check-square">
            <div class="preview p-4 text-center">
              <h1>Olá {{ this.formCadastro.nome }}, Seja Bem-Vindo ao Time</h1>
              <h4>
                Em breve chegará no E-mail cadastrado Informaçoes sobre o acesso
                a plataforma
              </h4>
              <h4>Voce será redirecionado ao site para nos conhecer melhor!</h4>
            </div>
          </tab-content>
        </form-wizard>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import locale from "../../locale";
import * as lang from "vuejs-datepicker/src/locale";
import cpfCnpj from "../../services/cpfCnpj";
import service from "../../services";
import moment from "moment";

export default {
  watch: {},
  data() {
    return {
      termoLgpd: null,
      active5: false,
      idUsuario: null,
      languages: lang,
      formCadastro: {
        idUsuario: null,
        nome: null,
        email: null,
        cpf: null,
        celular: null,
        dataNascimento: null,
        senha: null,
        senha2: null,
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        estado: null,
        pais: "Brasil",
        consultorOrigem: "Fluxo Embaixador",
        podeFazerVistoria: true,
        userName: null,
        consultor: true,
        aceitaLgpd: false,
        indicacao: false,
        nomeIndicacao: null,
        experiencia: false,
        consultorProspect: false,
      },
    };
  },
  methods: {
    onSubmitProspect() {
      return new Promise((resolve, reject) => {
        var action = "Adicionar";
        var msgRetorno = "Dados Adicionados com sucesso";
        this.$vs.loading();
        this.formCadastro.consultorProspect = true;
        this.formCadastro.userName = this.formCadastro.email;
        service
          .post("CadastroConsultor", action, this.formCadastro)
          .then((res) => {
            console.log(473, res);
            if (res.data.error) {
              this.formCadastro = res.data.error;
              this.formCadastro.senha = null
              this.formCadastro.dataNascimento = moment(
                res.data.error.dataNascimento
              )
                .utc()
                .format("DD/MM/YYYY");
            } else {
              this.formCadastro.idUsuario = res.data.idUsuario;
              this.formCadastro.dataNascimento = moment(
                this.formCadastro.dataNascimento
              )
                .utc()
                .format("DD/MM/YYYY");
            }
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: `Complete o Cadastro`,
              color: "success",
            });
            this.$vs.loading.close();
            resolve(true);
          })
          .catch((error) => {
            this.formCadastro.consultorProspect = false;
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: error,
              color: "danger",
            });
            this.$vs.loading.close();
            reject();
          });
      });
    },

    onSubmit() {
      this.idUsuario = this.formCadastro.idUsuario;
      this.formCadastro.consultorProspect = false;
      return new Promise((resolve, reject) => {
        var msgRetorno = "Dados Atualizados com sucesso";
        this.$vs.loading();
        service
          .post("CadastroConsultor", "Atualizar", this.formCadastro)
          .then((res) => {
            this.onComplete()
            this.aguardeCadastro = false;
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: `Operação Realizada com sucesso`,
              color: "success",
            });
            this.$vs.loading.close();
            resolve(true);
          })
          .catch((error) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: error,
              color: "danger",
            });
            this.$vs.loading.close();
            reject();
          });
      });
    },

    keymonitor2: function (event) {
      if (this.formCadastro.cpf.length == 14) {
        if (cpfCnpj.valida_cpf_cnpj(this.formCadastro.cpf) == false){
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: `Este CPF não é válido`,
            color: "danger",
          });
  
          return;
        }

        }
    },

    
    keymonitor: function (event) {
      if (this.formCadastro.cep.length == 10) {
        this.$vs.loading();
        var cepbusca = this.formCadastro.cep.replace(".", "").replace("-", "");
        service
          .post("g", "BuscaCEP", {
            cep: cepbusca,
          })
          .then((res) => {
            this.formCadastro.endereco = res.data.street;
            this.formCadastro.bairro = res.data.neighborhood;
            this.formCadastro.cidade = res.data.city;
            this.formCadastro.estado = res.data.state;
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Não Foi possível encontrar o cep",
              color: "danger",
            });
          });
      }
    },

    onComplete: function () {
      setTimeout(function() {
    window.location.href = "https://www.bemprotege.com.br/bem-protege";
}, 5000);
    },

    async validateStepOne() {
      if (
        this.veeFields.Nome.valid &&
        this.veeFields.Email.valid &&
        this.veeFields.AceitaLgpd.changed &&
        this.veeFields.Celular.valid
      ) {
        var res = await this.onSubmitProspect();
        return res;
      } else {
        this.$validator.validateAll().then((result) => {
          if (result) {
            return;
          }
        });
        return false;
      }
    },

    async validateStepTwo() {
      if (
        this.veeFields.CPF.valid &&
        this.veeFields.DataNascimento.valid &&
        this.veeFields.Senha.valid &&
        this.veeFields.Senha2.valid &&
        this.veeFields.Cep.valid &&
        this.veeFields.Endereco.valid &&
        this.veeFields.Numero.valid &&
        this.veeFields.Bairro.valid &&
        this.veeFields.Cidade.valid &&
        this.veeFields.Estado.valid
      ) {
        var res = await this.onSubmit();
        return res;
      } else {
        this.$validator.validateAll().then((result) => {
          if (result) {
            return;
          }
        });
        return (validateStep2 = false);
      }
    },

    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },

    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    exibirTermos() {
      this.active5 = !this.active5;
    },

    buscaTermoLGPD() {
      return new Promise((resolve, reject) => {
        this.carregando = true;
        this.$vs.loading();
        service
          .post("CadastroConsultor", "BuscaContratoLGPD", {})
          .then((res) => {
            this.termoLgpd = res.data[0].modeloContrato;
            this.termoLgpd = this.termoLgpd
              .replaceAll("<p>", "")
              .replaceAll("<b>", "")
              .replaceAll("</p>", "")
              .replaceAll("</b>", "")
              .slice(0, 1840)
              .replace("#NOME_ASSOCIACAO#", "BEM PROTEGE")
              .replace("#EMAIL_ASSOCIACAO#", "");
            console.log(this.termoLgpd);
            this.carregando = false;
            this.$vs.loading.close();
          })
          .catch((e) => {
            this.carregando = false;
            this.erroConexao =
              "Seu aplicativo parece estar offline, verifique sua conexao";
            this.$vs.loading.close();
          });
      });
    },
  },
  mounted() {
    this.buscaTermoLGPD();
  },
  components: {
    FormWizard,
    TabContent,
  },
};
</script>
<style>
.vue-form-wizard .wizard-tab-content {
  padding: 30px 0 10px;
}
.vx-card .vx-card__collapsible-content .vx-card__body {
  padding: 0 1rem;
}
.vue-form-wizard .wizard-card-footer {
  padding: 0 5px;
}
.vue-form-wizard .wizard-icon-circle .wizard-icon-container {
  border-radius: 50%;
  border: none;
}
.vue-form-wizard.md .wizard-navigation .wizard-nav .wizard-icon-circle {
  border: 1px solid #cccccc;
}
.divLgpd {
  font-size: .650rem;
  letter-spacing: 0px;
  /* padding-bottom: 10px; */

}
.lgpdLink,
a {
  cursor: pointer;
  color: #3498db !important;
  letter-spacing: 0px;
}
.lgpdAlert {
  top: 20px;
  z-index: 999;
  background: #f7fafd;
  position: absolute;
  padding: 40px;
}

.preview h1,
.preview h4 {
  color: rgb(59, 58, 58);
  margin-bottom: 20px;
}

body {
  background-color: white;
}
.logo {
  display: flex;
  justify-content: center;
  margin: 20px;
}
.valorprod {
  color: #000;
  font-weight: bolder;
  font-family: "roboto";
}
.con-slot-label {
  max-width: 90%;
  margin-left: 10px;
}
</style>
